import BaseApi from './base';

class Delivery extends BaseApi {
    endpoint = 'deliveries';
}

export default new Delivery();




// WEBPACK FOOTER //
// ./src/psuite-js/apis/delivery/delivery.js